module.exports = __webpack_public_path__ + "img/rappi-logo.bd20fabd.webp";